<script lang="ts">
	import cn from 'classnames';
	const cls = 'flex h-8 w-8 shrink-0 items-center justify-center rounded-full font-bold';
	const filledCls = 'text-white bg-gray-oslogray';
	const activeCls = 'bg-red text-white';
	const emptyCls = 'border-2 border-gray-oslogray bg-white text-gray-oslogray';
	export let producer: string | undefined = undefined;
	export let step: number;
</script>

<div class="mb-8 mt-6 flex items-center justify-center sm:my-9">
	<div class="mr-2.5 font-bold text-gray-shark xs:mr-5 xs:text-lg">
	<a href="/skutry/" title="Změnit výrobce">			
	{producer ?? 'Výrobce skútru'}</a>
	</div>

	<div class="flex items-center justify-center gap-x-4">
		<div class={cn(step === 1 ? activeCls : filledCls, cls)}>1</div>
		<div class="hidden h-[2px] w-12 bg-gray-oslogray xs:block" />
		<div class={cn(step === 2 ? activeCls : emptyCls, cls)}>2</div>
	</div>

	<div class="ml-2.5 text-gray-shark xs:ml-5 xs:text-lg">Typ skútru</div>
</div>
